export default __webpack_public_path__ + "static/media/hero-image.7bb92960.png";